// benvel-faq-deeplink.js — Progressive-enhancement deep-link bootstrap.
// Story 7.4, Decision §1: PE bootstrap (~150 bytes).
// On DOMContentLoaded, reads location.hash, finds the matched <details id="faq-*">,
// sets open=true, and scrolls into view.
// JS-disabled buyers fall back to :target CSS highlight + manual click (AC3 satisfied).
(function () {
  var hash = location.hash;
  if (!hash) return;
  var el = document.querySelector('details' + hash);
  if (!el) return;
  el.open = true;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  el.scrollIntoView({ block: 'start', behavior: reduce ? 'auto' : 'smooth' });
})();
